import React, { useEffect, useRef } from 'react'
import styles from './About.module.css'
import IconComponent from '../IconComponent/IconComponent'
import { FaPencilAlt, FaCamera, FaTiktok, FaInstagram } from 'react-icons/fa'
import { FaPhone } from 'react-icons/fa6'
import { TbWorld } from 'react-icons/tb'
import { IoMdPlayCircle, IoIosSend } from 'react-icons/io'
import { MdEmail } from 'react-icons/md'
import { useLocation } from 'react-router-dom'
import JumpingBar from '../JumpingBar/JumpingBar'
import SkillCard from './SkillCard/SkillCard'
import c1 from '../../assets/images/c1.jpg'
import Typewriter from '../TypeWritter/TypeWritter'
import emailjs from '@emailjs/browser';
import { useTranslation } from '../../TranslationProvider'

export type AboutProps = {
    setIsFooterVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
}

const About = (props: AboutProps) => {

    const contactRef = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const form = useRef<HTMLFormElement | null>(null);
    const { t } = useTranslation();

    const scrollToElementSmoothly = (element: HTMLElement, offset = 0, duration = 500) => {
        const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        let startTime: number | null = null;
    
        const animation = (currentTime: number) => {
            if (!startTime) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const ease = 1 - Math.pow(1 - progress, 3); // easeOutCubic
    
            window.scrollTo(0, startPosition + distance * ease);
    
            if (progress < 1) requestAnimationFrame(animation);
        };
    
        requestAnimationFrame(animation);
    };

    useEffect(() => {
        props.setIsFooterVisible(true);
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (location.hash === '#contact' && contactRef.current) {
            window.scrollTo(0, 0);
            setTimeout(() => {
                requestAnimationFrame(() => {
                    scrollToElementSmoothly(contactRef.current as HTMLElement, 80);
                });
            }, 100);
        }
    }, [location]);

    const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    
        if (!form.current) return;
    
        emailjs
            .sendForm(  
                process.env.REACT_APP_EMAILJS_SERVICE_ID!,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID!,
                form.current, {
                    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY!,
            })
            .then(
                () => {
                window.location.reload();
                },
                (error) => {
                console.log('FAILED...', error.text);
                },
            );
    };

    return (
        <div className={styles.section}>
            <div className={styles.about}>
                <span className={styles.title}>
                <Typewriter
                        texts={['NOT JUST CREATIVE...']}
                        speed={100}
                        pause={1500}
                    />
                </span>
                <span className={styles.headDesc}>
                    <Typewriter
                        texts={['HARD CREATIVE', 'HARD BRAND', 'HARD DESIGN', 'HARD IMPACT', 'HARD VISION']}
                        speed={100}
                        pause={1500}
                    />
                </span>
            </div>
            <div className={styles.about_section}>
                <div className={styles.info_hard}>
                    <div className={styles.info2}>
                        <img className={styles.logo} src={require('../../assets/images/Icon Logo.png')} alt="Logo" />
                        <span>Hard Creative Studio</span>
                    </div>
                    <div className={styles.info}>
                        <p className={styles.creative_skills}>
                            {t('creative_skills')}
                        </p>
                    </div>
                </div>
                <div className={styles.cards}>
                    <img src={require('../../assets/images/site_banner.jpg')} alt='Site Banner' style={{ width: '100%', height: 'auto' }} />
                </div>
                <div className={styles.info_hard}>
                    <div className={styles.info2}>
                        <img className={styles.logo} src={require('../../assets/images/Icon Logo.png')} alt="Logo" />
                        <span>{t('core_skills_title')}</span>
                    </div>
                    <div className={styles.info}>
                        <p className={styles.core_skills}>{t('core_skills')}</p>
                        <div className={styles.skills_cards}>
                            <SkillCard title={t('skill_card_1_title')} text={t('skill_card_1_text')} icon={FaPencilAlt} image={c1} desc={t('skill_card_1_desc')} />
                            <SkillCard title={t('skill_card_2_title')} text={t('skill_card_2_text')} icon={TbWorld} image={c1} desc={t('skill_card_2_desc')} />
                            <SkillCard title={t('skill_card_3_title')} text={t('skill_card_3_text')} icon={FaCamera} image={c1} desc={t('skill_card_3_desc')} />
                            <SkillCard title={t('skill_card_4_title')} text={t('skill_card_4_text')} icon={IoMdPlayCircle} image={c1} desc={t('skill_card_4_desc')} />
                        </div>
                    </div>
                </div>
                <div className={styles.cards2} ref={contactRef} id='contact'>
                    <div className={styles.cards2_overlay}>
                        <div className={styles.contact}>
                            <span className={styles.contact_title}>{t('contact_us')},</span>
                            <span className={styles.contact_desc}>{t('contact_desc')}</span>
                            <form onSubmit={sendEmail} ref={form} className={styles.form}>
                                <div className={styles.items}>
                                    <div className={styles.item}>
                                        <span id='name'>{t('name')}</span>
                                        <span><input type="text" placeholder={t('name')} name='name' /></span>
                                    </div>
                                    <div className={styles.item}>
                                        <span id='name'>{t('email')}</span>
                                        <span><input type="text" placeholder='youremail@email.com' name='email' /></span>
                                    </div>
                                </div>
                                <div className={styles.items}>
                                    <div className={styles.item}>
                                        <span id='message'>{t('message')}</span>
                                        <span><textarea name="message" id="message" placeholder={t('leave_message')}></textarea></span>
                                    </div>
                                </div>
                                <div className={styles.items}>
                                    <div className={styles.item}>
                                        <button type='submit'>
                                            <span>{t('send_message')}</span>
                                            <span><IconComponent icon={IoIosSend} size={25} /></span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className={styles.contact_info}>
                            <div className={styles.company_info}>
                                <span className={styles.company_info_title}>{t('contact_info')}</span>
                                <div className={styles.info_item}>
                                    <div className={styles.type_item}>
                                        <span className={styles.info_icon}><IconComponent icon={MdEmail} size={25} /></span>
                                        <span className={styles.info_type}>{t('email')}</span>
                                    </div>
                                    <div className={styles.type_item}>
                                        <span className={styles.info_icon2}><IconComponent icon={MdEmail} size={25} /></span>
                                        <a className={styles.hyperlink} href="mailto:studio@hardcreative.pt"><span>studio@hardcreative.pt</span></a>
                                    </div>
                                </div>
                                <div className={styles.info_item}>
                                    <div className={styles.type_item}>
                                        <span className={styles.info_icon3}><IconComponent icon={FaPhone} size={25} /></span>
                                        <span className={styles.info_type}>{t('phone')}</span>
                                    </div>
                                    <div className={styles.type_item}>
                                        <span className={styles.info_icon4}><IconComponent icon={FaPhone} size={25} /></span>
                                        <a className={styles.hyperlink} href="tel:+351 913 139 944"><span>+351 913 139 944</span></a>
                                    </div>
                                    <div className={styles.type_item}>
                                        <span className={styles.info_icon4}><IconComponent icon={FaPhone} size={25} /></span>
                                        <a className={styles.hyperlink} href="tel:+351 934 337 663"><span>+351 934 337 663</span></a>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.company_info}>
                                <span className={styles.company_info_title}>{t('follow_us')}</span>
                                <div className={styles.social_media}>
                                    <div className={styles.media_item}>
                                        <a href="https://www.instagram.com/hard.creative/" target="_blank" rel="noopener noreferrer">
                                            <span className={styles.info_icon}><IconComponent icon={FaInstagram} size={20} /></span>
                                            <span>Instagram</span>
                                        </a>
                                    </div>
                                    <div className={styles.media_item}>
                                        <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                                            <span className={styles.info_icon}><IconComponent icon={FaTiktok} size={20} /></span>
                                            <span>Tiktok</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <JumpingBar />
        </div>
    )
}

export default About